import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { Icon } from '@spaceshipapp/cambridge';
import useTranslation from 'next-translate/useTranslation';

const CarrierConstraintsRemarks: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <RootWrapper>
      <Icon.Info className={iconStyle} width={24} height={24} />
      <p>{t('ServiceSelection.carrierConstraintsRemarks')}</p>
    </RootWrapper>
  );
};

const RootWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 16px;
  background-color: #e5e5e5;
`;

const iconStyle = css`
  margin-right: 8px;
  flex: 0 0 auto;
`;

export default CarrierConstraintsRemarks;
